export default __webpack_public_path__ + "static/mb-product-mobile-2cc669c7708fecef8930a08748aba681.png";